import { Component, OnInit } from '@angular/core';
import { MenuItem } from '../core/interfaces/menu-items';
import { ActivatedRoute } from '@angular/router';
import { Pages } from '../core/constants/shared.constants';

@Component({
  selector: 'app-sms',
  templateUrl: './sms.component.html',
  styleUrls: ['./sms.component.scss']
})
export class SmsComponent implements OnInit {
  public module: string = "";
  public title: string = "";
  public menuItems: MenuItem[];

  constructor(private route: ActivatedRoute) { }

  ngOnInit() {
    this.module = this.route.snapshot.data.module;
    this.title = this.route.snapshot.data.menuTitle;
    this.getMenuItems();
  }

  private getMenuItems() {
    this.menuItems = [
      {
        title: 'Overview',
        url: `/sms/${Pages.Overview}`
      },
      {
        title: "Send SMS",
        url: `/sms/${Pages.SendRequest}`
      },
      {
        title: "Get SMS Info",
        url: `/sms/${Pages.GetStatus}`
      },
      {
        title: "SMS status",
        url: `/sms/${Pages.Status}`
      },
      
    ];
  }

}
